/*
 * Where Tutorials lives.
 *
 *   /tutorials                 the course, open at the newest tutorial
 *   /tutorials/:tutorialId     open at that tutorial
 *   /tutorials/:tutorialId?t=  ...starting that many seconds in
 */
export const TUTORIALS_PATH = "/tutorials";
